import React, { useState } from "react";
import emailjs from '@emailjs/browser';

// محصولات نمونه
const products = [
  { id: 1, name: "Ankle Boot", img: "/images/wow.jpg" },
  { id: 2, name: "Boot", img: "/images/belt heel.jpg" },
  { id: 3, name: "High-Heeled Shoes", img: "/images/sandals-34.jpg" },
  { id: 4, name: "Boot", img: "/images/download.jpg" },
  { id: 5, name: "Matte Boot", img: "/images/download1.jpg" },
  { id: 6, name: "Shiny Boot", img: "/images/download2.jpg" },
  { id: 7, name: "Slip-On Shoes", img: "/images/New2.jpg" },
  { id: 8, name: "High-Heeled Shoes", img: "/images/New.jpg" },
  { id: 9, name: "Slip-On Shoes", img: "/images/New1.jpg" },
  { id: 10, name: "Shiny Boot", img: "/images/download2.jpg" },
  { id: 11, name: "High-Heeled Shoes", img: "/images/New6.jpg" },
  { id: 12, name: "Slip-On Shoes", img: "/images/New4.jpg" },
  { id: 13, name: "High-Heeled Shoes", img: "/images/New5.jpg" },
  { id: 14, name: "Slip-On Shoes", img: "/images/New3.jpg" },
  { id: 16, name: "Boot", img: "/images/New8.jpg" },
  { id: 15, name: "Matte Boot", img: "/images/New7.jpg" },
].map(item => ({
  ...item,
  price: (Math.random() * 100 + 20).toFixed(2),
}));

// --- کامپوننت اصلی ---
export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("User");
  const [ordersCount, setOrdersCount] = useState(0);
  const [pendingShipments] = useState(0);
const [messagesCount] = useState(0);
const [accountBalance] = useState(0);
const [contactSubmitted, setContactSubmitted] = useState(false);

const sendEmail = (e) => {
  e.preventDefault();

  emailjs.sendForm(
  "service_ppzyqhu",
  "template_jt9rvfe",
  e.target,
  "wMK0pWL_GUXgiGsGS"  // کلید عمومی به صورت رشته
)

  .then(() => {
    setContactSubmitted(true);
    e.target.reset();
  })
  .catch((error) => {
    console.error("EmailJS error:", error);
    alert("Error sending message, please try again.");
  });
};
  // بعد از ورود
  const handleLogin = (email) => {
    setIsLoggedIn(true);
    setUserName(email.split("@")[0]);
  };

  // خروج از حساب
  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserName("User");
    setOrdersCount(0);
  };

  // کلیک روی دکمه خرید
  const handleBuyNow = () => {
    setOrdersCount(prev => prev + 1);
    alert("Product added to your orders!");
  };


  // بعد از لاگین، سایت کامل
  return (
    <div style={styles.page}>
      <header style={styles.header}>
        <div style={styles.logo}>MyBootChappal</div>
        <nav style={styles.nav}>
          <a href="#products" style={styles.navLink}>Products</a>
          <a href="#dashboard" style={styles.navLink}>Dashboard</a>
          <a href="#contact" style={styles.navLink}>Contact Us</a>
        </nav>
      </header>

      <section style={styles.banner}>
        <h1 style={styles.bannerTitle}>Welcome to MyBootChappal</h1>
        <p style={styles.bannerSubtitle}>High quality boots & chappals just for you</p>
      </section>

      <section id="products" style={styles.productsSection}>
        <h2 style={styles.sectionTitle}>Our Products</h2>
        <div style={styles.productsGrid}>
          {products.map(product => (
            <div key={product.id} style={styles.productCard} className="product-card">
              <img src={product.img} alt={product.name} style={styles.productImage} />
              <h3 style={styles.productName}>{product.name}</h3>
              <p style={styles.productPrice}>${product.price}</p>
              <button style={styles.buyButton} onClick={handleBuyNow}>Buy Now</button>
            </div>
          ))}
        </div>
      </section>

      <section id="dashboard" style={styles.section}>
        <h2 style={styles.sectionTitle}>Dashboard</h2>
        <DashboardPage
          userName={userName}
          onLogout={handleLogout}
          ordersCount={ordersCount}
          pendingShipments={pendingShipments}
          messagesCount={messagesCount}
          accountBalance={accountBalance}
        />
      </section>

      <section id="contact" style={styles.contactSection}>
  <h2 style={styles.sectionTitle}>Contact Us</h2>
  <p style={styles.contactIntro}>
    Have questions or want to work with us? Reach out anytime!
  </p>

  <div style={styles.contactContent}>
    {/* اطلاعات تماس */}
    <div style={styles.contactInfo}>
      <ContactInfoCard
        icon={
          <svg fill="#f5a623" height="32" viewBox="0 0 24 24" width="32">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM12 11.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
          </svg>
        }
        title="Address"
        details={<><p>Kabul, Afghanistan</p><p>Main Street 123</p></>}
      />
      <ContactInfoCard
        icon={
          <svg fill="#f5a623" height="32" viewBox="0 0 24 24" width="32">
            <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
          </svg>
        }
        title="Email"
        details={<a href="mailto:support@mybootchappal.com" style={styles.link}>marwahabibi789@gmail.com</a>}
      />
      <ContactInfoCard
        icon={
          <svg fill="#f5a623" height="32" viewBox="0 0 24 24" width="32">
            <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.21c1.2.48 2.5.74 3.85.74a1 1 0 011 1V20a1 1 0 01-1 1C9.94 21 3 14.06 3 6a1 1 0 011-1h3.5a1 1 0 011 1c0 1.35.26 2.65.74 3.85a1 1 0 01-.21 1.11l-2.41 2.41z"/>
          </svg>
        }
        title="Phone"
        details={<a href="https://t.me/MarwaHabibi2025" style={styles.link}>@MarwaHabibi2025</a>}
      />
    </div>

    {/* فرم تماس یا پیام تایید */}
    {!contactSubmitted ? (
      <form style={styles.contactForm} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            style={styles.input}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            style={styles.input}
            required
          />
          <input
            type="text"
            name="subject"
            placeholder="Subject"
            style={styles.input}
            required
          />
          <textarea
            name="message"
            placeholder="Message"
            style={styles.textarea}
            rows="5"
            required
          />
          <button type="submit" style={styles.sendButton}>
            Send Message
          </button>
        </form>
    ) : (
      <div style={{ ...styles.contactForm, textAlign: "center", paddingTop: "2rem" }}>
        <h3 style={{ color: "#2ecc71", marginBottom: "1rem" }}>Thank you for your message!</h3>
        <p style={{ marginBottom: "1rem" }}>
          We appreciate you reaching out. We'll get back to you shortly.
        </p>
        <p style={{ marginTop: "1rem" }}>
          Follow us on social media for updates and offers:
        </p>
        <div style={{ display: "flex", gap: "1rem", justifyContent: "center", marginTop: "0.5rem" }}>
  <a href="https://www.facebook.com/share/16b3U6mWpF/" target="_blank" rel="noopener noreferrer" style={{ color: "#f5a623" }}>
    <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
      <path d="M22 12.07C22 6.52 17.52 2 12 2S2 6.52 2 12.07C2 17.1 5.66 21.29 10.44 22v-7.03H7.9v-2.9h2.54V9.77c0-2.5 1.5-3.89 3.8-3.89 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.9h-2.34V22C18.34 21.29 22 17.1 22 12.07z" />
    </svg>
  </a>

  <a href="https://www.instagram.com/safahabibi111?igsh=aG55MXFpMHNnbnJv" target="_blank" rel="noopener noreferrer" style={{ color: "#f5a623" }}>
    <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
      <path d="M7.75 2h8.5A5.76 5.76 0 0122 7.75v8.5A5.76 5.76 0 0116.25 22h-8.5A5.76 5.76 0 012 16.25v-8.5A5.76 5.76 0 017.75 2zm0 2A3.76 3.76 0 004 7.75v8.5A3.76 3.76 0 007.75 20h8.5A3.76 3.76 0 0020 16.25v-8.5A3.76 3.76 0 0016.25 4h-8.5zm8.75 1.25a1 1 0 110 2 1 1 0 010-2zM12 7a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z" />
    </svg>
  </a>

  <a href="https://x.com/MarwaHabib48820" target="_blank" rel="noopener noreferrer" style={{ color: "#f5a623" }}>
    <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
      <path d="M22.46 6c-.77.35-1.6.59-2.46.7a4.3 4.3 0 001.88-2.37c-.83.49-1.75.84-2.72 1.03a4.28 4.28 0 00-7.29 3.9A12.12 12.12 0 013 5.1a4.28 4.28 0 001.33 5.7 4.22 4.22 0 01-1.94-.54v.06a4.28 4.28 0 003.43 4.2c-.45.12-.93.17-1.42.17-.34 0-.68-.03-1-.1a4.28 4.28 0 003.99 2.97A8.6 8.6 0 013 19.54a12.1 12.1 0 006.56 1.93c7.87 0 12.18-6.52 12.18-12.17 0-.18 0-.36-.01-.54A8.72 8.72 0 0024 5.5a8.53 8.53 0 01-2.54.7z" />
    </svg>
  </a>
</div>

      </div>
    )}
  </div>

  {/* نقشه */}
  <div style={styles.mapWrapper}>
    <iframe
      title="Location Map"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3303.945177991399!2d69.19626991523067!3d34.55534958046507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38d8f099a7ae75b1%3A0x3556d5e48240c3b1!2sKabul%20City%20Center!5e0!3m2!1sen!2saf!4v1688562793689!5m2!1sen!2saf"
      style={styles.map}
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
    />
  </div>
</section>


      <footer style={styles.footer}>
        <p>© 2025 MyBootChappal. All rights reserved.</p>
      </footer>

      {/* انیمیشن محصولات */}
      <style>{`
        .product-card {
          opacity: 0;
          transform: translateY(20px);
          animation: fadeInUp 0.6s forwards;
        }
        .product-card:nth-child(odd) {
          animation-delay: 0.15s;
        }
        .product-card:nth-child(even) {
          animation-delay: 0.3s;
        }
        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @media (max-width: 1024px) {
          div[style*="productsGrid"] {
            grid-template-columns: repeat(3, 1fr) !important;
          }
        }
        @media (max-width: 768px) {
          div[style*="productsGrid"] {
            grid-template-columns: repeat(2, 1fr) !important;
          }
          div[style*="contactContent"] {
            flex-direction: column !important;
          }
          div[style*="contactInfo"] {
            flex-direction: row !important;
            justify-content: space-around !important;
            margin-bottom: 2rem !important;
          }
          form[style*="contactForm"] {
            width: 100% !important;
          }
        }
        @media (max-width: 480px) {
          div[style*="productsGrid"] {
            grid-template-columns: 1fr !important;
          }
          div[style*="contactInfo"] {
            flex-direction: column !important;
          }
        }
          .dashboard-card {
    opacity: 0;
    transform: translateY(20px);
    animation: fadeDashboard 0.6s ease forwards;
  }
  .dashboard-card:nth-child(1) { animation-delay: 0.2s; }
  .dashboard-card:nth-child(2) { animation-delay: 0.4s; }
  .dashboard-card:nth-child(3) { animation-delay: 0.6s; }
  .dashboard-card:nth-child(4) { animation-delay: 0.8s; }

  @keyframes fadeDashboard {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
      `}</style>
    </div>
  );
}

// --- صفحه لاگین ---
function LoginPage({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isRegistering, setIsRegistering] = useState(false);

  const isFormValid = email.trim() !== "" && password.trim() !== "";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isFormValid) return;

    const savedEmail = localStorage.getItem("savedEmail");
    const savedPassword = localStorage.getItem("savedPassword");

    if (isRegistering) {
      // ثبت‌نام فقط یک بار مجاز است
      if (savedEmail === email) {
        setError("This email is already registered. Please log in.");
        setIsRegistering(false); // برگرد به لاگین
      } else if (!savedEmail) {
        localStorage.setItem("savedEmail", email);
        localStorage.setItem("savedPassword", password);
        setError("");
        setIsRegistering(false);
        alert("Registration successful. You can now log in.");
      } else {
        setError("Only one registration is allowed.");
        setIsRegistering(false);
      }
    } else {
      // لاگین
      if (savedEmail && savedPassword) {
        if (email === savedEmail && password === savedPassword) {
          setError("");
          if (onLogin) onLogin(email);
        } else {
          setError("Incorrect email or password.");
        }
      } else {
        setError("No account found. Please register.");
        setIsRegistering(true);
      }
    }
  };

  return (
    <div style={stylesLogin.page}>
      <form style={stylesLogin.form} onSubmit={handleSubmit} noValidate>
        <h2 style={stylesLogin.title}>
          {isRegistering ? "Register a New Account" : "Login to Your Account"}
        </h2>

        <input
          type="email"
          placeholder="Email Address"
          style={stylesLogin.input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          style={stylesLogin.input}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {error && <p style={{ color: "red", fontSize: "0.9rem" }}>{error}</p>}

        <button
          type="submit"
          style={{
            ...stylesLogin.button,
            opacity: isFormValid ? 1 : 0.6,
            cursor: isFormValid ? "pointer" : "not-allowed",
          }}
          disabled={!isFormValid}
        >
          {isRegistering ? "Register" : "Login"}
        </button>

        <p style={stylesLogin.text}>
          {isRegistering ? (
            <>
              Already have an account?{" "}
              <span
                onClick={() => {
                  setIsRegistering(false);
                  setError("");
                }}
                style={stylesLogin.link}
              >
                Login here
              </span>
            </>
          ) : (
            <>
              Don't have an account?{" "}
              <span
                onClick={() => {
                  setIsRegistering(true);
                  setError("");
                }}
                style={stylesLogin.link}
              >
                Register
              </span>
            </>
          )}
        </p>
      </form>
    </div>
  );
}

// --- داشبورد ---
function DashboardPage({ userName, onLogout, ordersCount, pendingShipments, messagesCount, accountBalance }) {
  return (
    <div style={stylesDashboard.page}>
      <header style={stylesDashboard.header}>
        <h1 style={stylesDashboard.welcome}>
          Welcome, <span style={stylesDashboard.userName}>{userName}</span>
        </h1>
      </header>

      <section style={stylesDashboard.statsSection}>
        <h2 style={stylesDashboard.sectionTitle}>Your Activity Overview</h2>
        <div style={stylesDashboard.cardsGrid}>
          <DashboardCard title="Orders" value={ordersCount} icon="📦" color="#f5a623" />
          <DashboardCard title="Pending Shipments" value={pendingShipments} icon="🚚" color="#61dafb" />
          <DashboardCard title="Messages" value={messagesCount} icon="✉️" color="#8e44ad" />
          <DashboardCard title="Balance" value={`$${accountBalance.toFixed(2)}`} icon="💰" color="#2ecc71" />
        </div>
      </section>
    </div>
  );
}

function DashboardCard({ title, value, icon, color }) {
  return (
    <div style={{ ...stylesDashboard.card, borderTop: `4px solid ${color}` }} className="dashboard-card">
      <div style={{ ...stylesDashboard.cardIcon, color }}>{icon}</div>
      <h3 style={stylesDashboard.cardTitle}>{title}</h3>
      <p style={stylesDashboard.cardValue}>{value}</p>
    </div>
    
  );
}


// --- کارت اطلاعات تماس ---
function ContactInfoCard({ icon, title, details }) {
  return (
    <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
      <div style={{ flexShrink: 0 }}>{icon}</div>
      <div>
        <h3 style={{ margin: 0, color: "#f5a623" }}>{title}</h3>
        <div>{details}</div>
      </div>
    </div>
  );
}

// --- استایل‌ها ---
const styles = {
  page: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    backgroundColor: "#121212",
    color: "#eee",
    minHeight: "100vh",
  },
  header: {
    display: "flex",
    padding: "1rem 3rem",
    backgroundColor: "#222",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "2px solid #f5a623",
    flexWrap: "wrap",
  },
  logo: {
    fontWeight: "900",
    fontSize: "1.8rem",
    letterSpacing: "0.1rem",
    color: "#f5a623",
  },
  nav: {
    display: "flex",
    gap: "1.3rem",
    flexWrap: "wrap",
    alignItems: "center",
  },
  navLink: {
    color: "#eee",
    textDecoration: "none",
    fontWeight: "600",
    fontSize: "1rem",
    cursor: "pointer",
  },
  logoutButton: {
    backgroundColor: "#f5a623",
    border: "none",
    borderRadius: "8px",
    color: "#121212",
    fontWeight: "700",
    padding: "0.5rem 1rem",
    cursor: "pointer",
  },
  banner: {
    padding: "4rem 2rem",
    textAlign: "center",
    background: "linear-gradient(135deg, #f5a623, #121212)",
    color: "#121212",
  },
  bannerTitle: {
    fontSize: "3.2rem",
    fontWeight: "900",
    marginBottom: "0.6rem",
  },
  bannerSubtitle: {
    fontSize: "1.4rem",
    fontWeight: "600",
  },
  productsSection: {
    padding: "3rem 2rem",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  sectionTitle: {
    fontSize: "2rem",
    fontWeight: "700",
    marginBottom: "2rem",
    textAlign: "center",
  },
  productsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "1.8rem",
  },
  productCard: {
    backgroundColor: "#222",
    borderRadius: "10px",
    padding: "1rem",
    boxShadow: "0 0 8px rgba(0,0,0,0.8)",
    textAlign: "center",
    transition: "transform 0.3s",
    cursor: "pointer",
  },
  productImage: {
    width: "100%",
    height: "180px",
    objectFit: "cover",
    borderRadius: "8px",
  },
  productName: {
    fontSize: "1.1rem",
    fontWeight: "600",
    margin: "1rem 0 0.5rem",
  },
  productPrice: {
    fontWeight: "700",
    fontSize: "1rem",
    color: "#f5a623",
  },
  buyButton: {
    marginTop: "1rem",
    backgroundColor: "#f5a623",
    border: "none",
    padding: "0.5rem 1.2rem",
    borderRadius: "8px",
    fontWeight: "700",
    color: "#121212",
    cursor: "pointer",
  },
  section: {
    padding: "3rem 2rem",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  contactSection: {
    padding: "3rem 2rem",
    maxWidth: "1200px",
    margin: "0 auto",
    backgroundColor: "#222",
    borderRadius: "10px",
  },
  contactIntro: {
    fontSize: "1.2rem",
    marginBottom: "2rem",
    textAlign: "center",
  },
  contactContent: {
    display: "flex",
    gap: "3rem",
    marginBottom: "3rem",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  contactInfo: {
    flex: "1 1 300px",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
  },
  contactForm: {
    flex: "1 1 400px",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  input: {
    padding: "0.7rem 1rem",
    borderRadius: "6px",
    border: "1px solid #444",
    fontSize: "1rem",
    backgroundColor: "#333",
    color: "#eee",
  },
  textarea: {
    padding: "0.7rem 1rem",
    borderRadius: "6px",
    border: "1px solid #444",
    fontSize: "1rem",
    backgroundColor: "#333",
    color: "#eee",
    resize: "vertical",
  },
  sendButton: {
    backgroundColor: "#f5a623",
    border: "none",
    borderRadius: "8px",
    color: "#121212",
    fontWeight: "700",
    padding: "0.7rem",
    cursor: "pointer",
    fontSize: "1rem",
  },
  mapWrapper: {
    maxWidth: "100%",
    height: "300px",
    borderRadius: "10px",
    overflow: "hidden",
  },
  map: {
    width: "100%",
    height: "100%",
    border: "none",
  },
  link: {
    color: "#f5a623",
    textDecoration: "none",
  },
  footer: {
    padding: "1rem",
    textAlign: "center",
    backgroundColor: "#222",
    color: "#fffff",
    marginTop: "3rem",
  },
};

// --- استایل‌های صفحه لاگین ---
const stylesLogin = {
  page: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#121212",
    color: "#eee",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  form: {
    backgroundColor: "#222",
    padding: "3rem 2.5rem",
    borderRadius: "10px",
    width: "320px",
    boxShadow: "0 0 10px rgba(0,0,0,0.8)",
    textAlign: "center",
  },
  title: {
    marginBottom: "1.8rem",
    fontWeight: "900",
    fontSize: "1.8rem",
  },
  input: {
    width: "100%",
    padding: "0.8rem 1rem",
    marginBottom: "1rem",
    borderRadius: "6px",
    border: "1px solid #444",
    backgroundColor: "#333",
    color: "#eee",
    fontSize: "1rem",
  },
  button: {
    width: "100%",
    padding: "0.8rem",
    backgroundColor: "#f5a623",
    border: "none",
    borderRadius: "8px",
    color: "#121212",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  text: {
    marginTop: "1rem",
    fontSize: "0.9rem",
  },
  link: {
    color: "#f5a623",
    textDecoration: "none",
  },
};

// --- استایل‌های داشبورد ---
const stylesDashboard = {
  page: {
    backgroundColor: "#1e1e1e",
    padding: "3rem 2rem",
    borderRadius: "12px",
    color: "#eee",
    fontFamily: "'Segoe UI', sans-serif",
    boxShadow: "0 0 15px rgba(0,0,0,0.6)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "2.5rem",
    flexWrap: "wrap",
  },
  welcome: {
    fontSize: "2rem",
    fontWeight: "700",
    marginBottom: "0.8rem",
  },
  userName: {
    color: "#f5a623",
  },
  logoutButton: {
    backgroundColor: "#f5a623",
    border: "none",
    borderRadius: "10px",
    color: "#121212",
    padding: "0.6rem 1.4rem",
    fontWeight: "700",
    fontSize: "1rem",
    cursor: "pointer",
    transition: "all 0.3s",
  },
  statsSection: {
    marginTop: "1rem",
  },
  sectionTitle: {
    fontSize: "1.8rem",
    marginBottom: "2rem",
    color: "#ffffff",
    fontWeight: "700",
    textAlign: "center",
  },
  cardsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "1.8rem",
  },
  card: {
    backgroundColor: "#2c2c2c",
    padding: "1.5rem",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.4)",
    textAlign: "center",
    transition: "transform 0.3s ease",
    cursor: "pointer",
  },
  cardIcon: {
    fontSize: "2.5rem",
    marginBottom: "1rem",
  },
  cardTitle: {
    fontWeight: "600",
    fontSize: "1.1rem",
    marginBottom: "0.5rem",
    color: "#ccc",
  },
  cardValue: {
    fontWeight: "800",
    fontSize: "1.5rem",
    color: "#fff",
  },
  
};